import { render, staticRenderFns } from "./arrivals_v1.vue?vue&type=template&id=6e31286c&scoped=true"
import script from "./arrivals_v1.vue?vue&type=script&lang=js"
export * from "./arrivals_v1.vue?vue&type=script&lang=js"
import style0 from "./arrivals_v1.vue?vue&type=style&index=0&id=6e31286c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e31286c",
  null
  
)

export default component.exports